import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { logoutUser } from '../../lib/common';
import HButton from '../common/HButton';

const NavBackground = styled.div`
  background-color: #eeeff0;
`;

const NavBar = styled.div`
  margin: auto auto auto auto;
  width: 1240px;
  height: 65px;
  max-width: 1240px;
  padding: 0 40px 0 40px;
  background-color: #eeeff0;
`;

const Nav = styled.div`
  display: flex;
  height: 65px;
  justify-content: space-between;
  align-items: center;

  #nav {
    list-style: none; //remove bullet
    display: flex;
    height: 100%;
    padding: 0;
    margin: 0;
    background: #eeeff0;
  }

  #nav li {
    position: relative;
    margin: 0;
    padding: 0;
    /* width: 125px; */
    margin-right: 45px;
    &:last-child {
      margin-right: 0px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #nav ul {
    z-index: 10;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left: -30px;
    top: 55px;
    width: 170px;
    background: white;
    text-align: center;
    border: solid 1px #e7e9ea;
    border-radius: 4px;

    visibility: hidden; //hide subMenu
  }

  #nav li:hover ul {
    visibility: visible;
  }

  #nav li:not(:hover) ul {
    visibility: hidden !important;
  }

  #nav li:hover ul li {
    width: 100%;
    height: 40px;
    overflow: visible;
    padding: 0;
  }

  #nav li span {
    display: flex;
    font-family: Source Sans Pro;
    font-weight: 600;
    font-size: 15px;
    padding: 0;
    margin: 0;
    color: #59616a;
    height: 21px;
    /* text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3); */
  }

  #nav li:hover span {
    text-decoration: none;
    cursor: pointer;
    margin: 0;
    /* padding: 5px; */
  }

  //combo list css
  #nav ul li {
    float: none; //vertical display
    margin: 0;
    padding: 0;
    font-size: 15px;
    height: 40px;

    &:first-child {
      margin-top: 8px;
    }
    &:last-child {
      margin-bottom: 8px;
    }
  }

  #nav li:hover > ul {
    visibility: visible !important;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  font-weight: normal;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 0 0 0 15px;

  font-family: Source Sans Pro;
  font-size: 15px;
  color: #59616a;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.33;

  &:hover {
    background: #eeeff0;
  }

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const Title = styled.span`
  font-family: 'Source Sans Pro';
  font-weight: normal;
  font-size: 25px;
  color: #59616a;
`;

const CSTop = () => {
  const dispatch = useDispatch();
  const { odm, user } = useSelector(({ app, user }) => ({
    odm: app.odm,
    user: user.user,
  }));
  const is3DISC = odm.company_name === '3DISC';
  // const isVatech = odm.company_name === 'vatech';
  const is3DiscAdmin = is3DISC && user.is_staff;
  const [menuClicked, setMenuClicked] = useState(false);
  const visible = { visibility: 'visible' };

  const onShowSubMenu = (e) => {
    setMenuClicked(true);
  };

  return (
    <NavBackground>
      <NavBar>
        <Nav>
          <Title>{'Administration'}</Title>

          {/* {is3DISC && ( */}
          <ul id="nav">
            {is3DiscAdmin && (
              <li>
                <StyledLink
                  style={{ fontWeight: 600, height: '65px', padding: 0 }}
                  to="/adm/dashboard"
                >
                  Dashboard
                </StyledLink>
              </li>
            )}

            {(user.is_device_manager || user.is_sales_manager) && (
              <li onClick={onShowSubMenu}>
                <span>
                  Registration &nbsp;
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/images/login/icon-24-arrow-down-active.svg'
                    }
                    alt="Arrow-down"
                  />
                </span>
                <ul style={menuClicked ? visible : null}>
                  {user.is_device_manager && (
                    <li>
                      <StyledLink to="/adm/registration">User Registrations</StyledLink>
                    </li>
                  )}
                  {user.is_device_manager && (
                    <li>
                      <StyledLink to="/adm/registration/tickets">Tickets</StyledLink>
                    </li>
                  )}
                  {is3DISC && (user.is_device_manager || user.is_sales_manager) && (
                    <li>
                      <StyledLink to="/adm/devices">Factory Registrations</StyledLink>
                    </li>
                  )}
                  {is3DISC && (
                    <li>
                      <StyledLink to="/adm/factory-registration">
                        Support Registration
                      </StyledLink>
                    </li>
                  )}
                  {/* Feature partner page */}
                  <li>
                    <StyledLink to="/adm/feature_partner">
                      Shade Matching Partner
                    </StyledLink>
                  </li>
                  {/* C4w partner page */}
                  <li style={{ position: 'relative' }}>
                    <StyledLink style={{ width: '170px', paddingRight: 0 }}>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <span style={{ fontWeight: 'normal' }}>C4W</span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            '/images/login/icon-24-arrow-down-active.svg'
                          }
                          alt="Arrow-right"
                          style={{
                            width: '18px',
                            height: '18px',
                            transform: 'rotate(-90deg)',
                          }}
                        />
                      </span>
                    </StyledLink>
                    <ul
                      style={{
                        left: '170px',
                        top: '0',
                        position: 'absolute',
                        background: 'white',
                        border: '1px solid #e7e9ea',
                        borderRadius: '4px',
                        minWidth: '170px',
                      }}
                    >
                      <li>
                        <StyledLink to="/adm/c4w/licences/">C4W Licence</StyledLink>
                      </li>
                      <li>
                        <StyledLink to="/adm/c4w/registration/">
                          C4W Registration
                        </StyledLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            )}
            {is3DiscAdmin && (
              <li>
                <span>
                  Data &nbsp;
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/images/login/icon-24-arrow-down-active.svg'
                    }
                    alt="Arrow-down"
                  />
                </span>
                <ul style={menuClicked ? visible : null}>
                  <li>
                    <StyledLink to="/adm/users">Users</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/adm/user-locations">User Locations</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/adm/cases">Cases</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/adm/connections">Connections</StyledLink>
                  </li>
                </ul>
              </li>
            )}

            {is3DISC && (
              <li>
                {/* <a href="/adm/labs" style={{ textDecoration: 'none' }}>
                  <span>Dental Lab</span>
                </a> */}
                <StyledLink
                  style={{ fontWeight: 600, height: '65px', padding: 0 }}
                  to="/adm/labs"
                >
                  Dental Lab
                </StyledLink>
              </li>
            )}

            {user.is_staff && (
              <li>
                <StyledLink
                  style={{ fontWeight: 600, height: '65px', padding: 0 }}
                  to="/adm/ai-feedback"
                >
                  AI Feedback
                </StyledLink>
              </li>
            )}

            {user.is_device_manager && (
              <li>
                <StyledLink
                  style={{ fontWeight: 600, height: '65px', padding: 0 }}
                  to="/adm/logs"
                >
                  Logs
                </StyledLink>
              </li>
            )}
          </ul>
          {/* )} */}

          {/* {isVatech && (
            <ul id="nav">
              <li onClick={onShowSubMenu}>
                <span>
                  Registration &nbsp;
                  <img
                    src={process.env.PUBLIC_URL + '/images/login/icon-24-arrow-down-active.svg'}
                    alt="Arrow-down"
                  />
                </span>
                <ul style={menuClicked ? visible : null}>
                  <li>
                    <StyledLink to="/adm/registration">User Registrations</StyledLink>
                  </li>
                  <li>
                    <StyledLink to="/adm/registration/tickets">Tickets</StyledLink>
                  </li>
                </ul>
              </li>
            </ul>
          )} */}
          {/* {user.first_name} {user.last_name} */}
          <HButton
            category="Tertiary"
            size="Small"
            text={'Sign out'}
            width="auto"
            onClick={() => {
              logoutUser(dispatch);
            }}
          ></HButton>
        </Nav>
      </NavBar>
    </NavBackground>
  );
};

export default React.memo(CSTop);
